<div class="welcomeText">
    <h3 style="width: 100%;">{{dataJson["Ueberschrift"]}} <b><span>{{dataJson["UeberschriftStyle"]}}</span></b></h3>
    <div class="imageDiv">
        <div class="imageDivC" style="width: 100% ;display: flex; justify-content: center; align-items: center; flex-direction: column;">
            <img src="./assets/img/people/Siglinde.webp" data-aos="fade-up" alt="">
        </div>
        
        <div class="text" style="font-weight: 200;" >
            <span>{{dataJson["ErsterTextBlock"]}}</span>
            <br>
            <span>{{dataJson["ZweiterTextBlock1"]}} <a aria-label="Telefonnummer" style="color: rgb(50, 100, 50);" href="tel:{{dataJson['Telefonnummer']}}">{{dataJson["Telefonnummer"]}}</a> {{dataJson["ZweiterTextBlock2"]}}</span>
            <br>
            <span>{{ dataJson["DritterTextBlock"] }}</span>
            <br>
        </div>
    </div>
    
    <div class="TeamButton" style="padding-top: 50px;">
        <a aria-label="Weiter zum Kontaktformular" routerLink="/kontakt">{{ dataJson["Button"] }}</a>
    </div>
    
</div>